const dominantEnergyMeanings = {
  "Sinh khí": {
    description: 
      `Tính cách: Siêu lạc quan, bình tĩnh, tỉnh táo, suy nghĩ sôi nổi, linh hoạt. Có khả năng điều phối, hòa giải mạnh mẽ. Càng nhiều Sinh Khí càng có EQ cao. Không tính toán, xử lý công việc hợp lý.
      Tài vận: Nhóm có nhiều cơ may nhất. Luôn có phúc đức giúp vượt qua khó khăn. Hay gặp may mắn bất ngờ lớn về tiền bạc.
      Sự nghiệp: Được quý nhân giúp đỡ nhiều. Có khả năng biến nguy thành an. Không cầu toàn trong công việc.
      Tình cảm: Hài hước, thông minh. Tạo ra bầu không khí vui vẻ, hài hòa. Luôn làm người khác cảm nhận được vị ngọt của tình yêu.
      Hôn nhân: Dễ giải quyết các vấn đề phức tạp về tình cảm, gia đình. Khiến cả hai vợ chồng đều có hạnh phúc, ngọt ngào.
      Mối quan hệ: Dễ giao lưu do có tính cách thuận theo duyên. Luôn bận rộn vì giúp đỡ người khác.
      Sức khỏe: Lạc quan nên là ánh sáng cho nhiều từ trường số về sức khỏe. Nếu gặp các số tiêu cực thì hay bị các chứng bệnh nhẹ về dạ dày, mắt, tai, mũi.
      Học tập: Được quý nhân giúp đỡ, kết quả học tập tốt. Không thích học cứng nhắc, thích phương pháp dạy học tương tác. Năng lực logic và toán học cao.
      Ưu điểm: Lạc quan, không câu nệ. Luôn tập trung thực hiện tốt vai trò của mình. Mang lại năng lượng tốt lành cho người xung quanh.
      Nhược điểm: Thiếu bền bỉ để theo đuổi công việc. Quá hào phóng nên dễ gây ghen tỵ.
      Kiểu tương tác của Sinh Khí:
        --- Sống hòa đồng, thoải mái
        --- Không để ý đến tiền nong với người khác
        --- Xử lý mọi việc điều hòa, có thể xoa dịu xung đột tự nhiên
        --- Thường đóng vai trò người hòa giải, giỏi giao tiếp
        --- Quá nhiều Sinh Khí sẽ thiếu chủ kiến và động lực phấn đấu`,
  },
  "Thiên y": {
    description: `Tính cách: Thông minh, nhạy bén, có trực giác tốt. Có khả năng học hỏi nhanh, tiếp thu kiến thức mới dễ dàng. Có khả năng sáng tạo, đổi mới.
    Tài vận: Có tài lộc, tiền bạc dồi dào. Có khả năng kiếm tiền tốt, biết cách quản lý tài chính. Có nhiều cơ hội đầu tư sinh lời.
    Sự nghiệp: Có sự nghiệp phát triển, thăng tiến nhanh chóng. Có khả năng lãnh đạo, quản lý tốt. Được đồng nghiệp, cấp trên yêu quý.
    Tình cảm: Có tình cảm chân thành, sâu sắc. Biết cách quan tâm, chăm sóc người khác. Có nhiều mối quan hệ tốt đẹp.
    Hôn nhân: Có cuộc sống gia đình hạnh phúc, hòa thuận. Biết cách vun đắp tình cảm vợ chồng. Có con cái ngoan ngoãn, hiếu thảo.
    Mối quan hệ: Có nhiều bạn bè tốt, được mọi người yêu quý. Có khả năng giao tiếp tốt, dễ dàng kết bạn.
    Sức khỏe: Có sức khỏe tốt, ít bệnh tật. Có tinh thần lạc quan, yêu đời.
    Học tập: Có khả năng học tập tốt, đạt kết quả cao. Có nhiều cơ hội học tập, phát triển bản thân.
    Ưu điểm: Thông minh, nhạy bén, có trực giác tốt. Có khả năng học hỏi nhanh, tiếp thu kiến thức mới dễ dàng. Có khả năng sáng tạo, đổi mới.
    Nhược điểm: Đôi khi quá tự tin, chủ quan. Dễ bị căng thẳng, stress.
    Kiểu tương tác của Thiên Y:
      --- Sống tình cảm, chân thành
      --- Quan tâm, chăm sóc người khác
      --- Có trách nhiệm với gia đình, bạn bè
      --- Thường đóng vai trò người tư vấn, giúp đỡ
      --- Quá nhiều Thiên Y sẽ dễ bị lợi dụng, lừa dối`,
  },
  "Diên niên": {
    description: `Tính cách: Điềm tĩnh, ôn hòa, có trách nhiệm. Có khả năng giao tiếp tốt, được nhiều người yêu quý. Có khả năng giải quyết vấn đề tốt.
    Tài vận: Có tài lộc ổn định, không quá giàu có nhưng đủ ăn đủ tiêu. Biết cách quản lý tài chính, không lãng phí.
    Sự nghiệp: Có sự nghiệp ổn định, không quá nổi bật nhưng vững chắc. Có khả năng làm việc nhóm tốt. Được đồng nghiệp, cấp trên tin tưởng.
    Tình cảm: Có tình cảm chân thành, sâu sắc. Biết cách quan tâm, chăm sóc người khác. Có nhiều mối quan hệ tốt đẹp.
    Hôn nhân: Có cuộc sống gia đình hạnh phúc, hòa thuận. Biết cách vun đắp tình cảm vợ chồng. Có con cái ngoan ngoãn, hiếu thảo.
    Mối quan hệ: Có nhiều bạn bè tốt, được mọi người yêu quý. Có khả năng giao tiếp tốt, dễ dàng kết bạn.
    Sức khỏe: Có sức khỏe tốt, ít bệnh tật. Có tinh thần lạc quan, yêu đời.
    Học tập: Có khả năng học tập tốt, đạt kết quả khá. Có nhiều cơ hội học tập, phát triển bản thân.
    Ưu điểm: Điềm tĩnh, ôn hòa, có trách nhiệm. Có khả năng giao tiếp tốt, được nhiều người yêu quý. Có khả năng giải quyết vấn đề tốt.
    Nhược điểm: Đôi khi quá bảo thủ, cứng nhắc. Dễ bị căng thẳng, stress.
    Kiểu tương tác của Diên Niên:
      --- Sống hòa đồng, thân thiện
      --- Có trách nhiệm với gia đình, bạn bè
      --- Thường đóng vai trò người hòa giải, giúp đỡ
      --- Quá nhiều Diên Niên sẽ dễ bị phụ thuộc, thiếu quyết đoán`,
  },
  "Phục vị": {
    description: `Tính cách: Hiền lành, tốt bụng, có lòng trắc ẩn. Có khả năng thấu hiểu, cảm thông với người khác. Có tinh thần lạc quan, yêu đời.
    Tài vận: Có tài lộc ổn định, không quá giàu có nhưng đủ ăn đủ tiêu. Biết cách tiết kiệm, không lãng phí.
    Sự nghiệp: Có sự nghiệp ổn định, không quá nổi bật nhưng vững chắc. Có khả năng làm việc độc lập tốt. Được đồng nghiệp, cấp trên tin tưởng.
    Tình cảm: Có tình cảm chân thành, sâu sắc. Biết cách quan tâm, chăm sóc người khác. Có nhiều mối quan hệ tốt đẹp.
    Hôn nhân: Có cuộc sống gia đình hạnh phúc, hòa thuận. Biết cách vun đắp tình cảm vợ chồng. Có con cái ngoan ngoãn, hiếu thảo.
    Mối quan hệ: Có nhiều bạn bè tốt, được mọi người yêu quý. Có khả năng giao tiếp tốt, dễ dàng kết bạn.
    Sức khỏe: Có sức khỏe tốt, ít bệnh tật. Có tinh thần lạc quan, yêu đời.
    Học tập: Có khả năng học tập tốt, đạt kết quả khá. Có nhiều cơ hội học tập, phát triển bản thân.
    Ưu điểm: Hiền lành, tốt bụng, có lòng trắc ẩn. Có khả năng thấu hiểu, cảm thông với người khác. Có tinh thần lạc quan, yêu đời.
    Nhược điểm: Đôi khi quá cả tin, dễ bị lợi dụng. Dễ bị căng thẳng, stress.
    Kiểu tương tác của Phục Vị:
      --- Sống tình cảm, chân thành
      --- Quan tâm, chăm sóc người khác
      --- Có trách nhiệm với gia đình, bạn bè
      --- Thường đóng vai trò người lắng nghe, chia sẻ
      --- Quá nhiều Phục Vị sẽ dễ bị phụ thuộc, thiếu quyết đoán`,
  },
  "Họa hại": {
    description: `Tính cách: Nóng nảy, dễ cáu gắt, hay gây gổ. Có xu hướng bi quan, tiêu cực. Dễ bị căng thẳng, stress.
    Tài vận: Có tài lộc kém, dễ bị mất mát tiền bạc. Có nhiều khoản chi tiêu không cần thiết. Dễ bị lừa gạt, mất tiền oan.
    Sự nghiệp: Có sự nghiệp không ổn định, dễ gặp khó khăn, trắc trở. Dễ bị đồng nghiệp, cấp trên ghét bỏ.
    Tình cảm: Có tình cảm không ổn định, dễ xảy ra mâu thuẫn, cãi vã. Dễ bị phản bội, lừa dối.
    Hôn nhân: Có cuộc sống gia đình không hạnh phúc, dễ xảy ra ly hôn. Có con cái không ngoan ngoãn, hiếu thảo.
    Mối quan hệ: Có ít bạn bè, dễ bị cô lập. Dễ gây gổ, mâu thuẫn với người khác.
    Sức khỏe: Có sức khỏe kém, dễ mắc bệnh tật. Có tinh thần bi quan, dễ nản chí.
    Học tập: Có khả năng học tập kém, khó đạt kết quả cao. Dễ bị xao nhãng, mất tập trung.
    Ưu điểm: Có khả năng phản biện tốt, không dễ bị lừa gạt. Có ý chí mạnh mẽ, không dễ bỏ cuộc.
    Nhược điểm: Nóng nảy, dễ cáu gắt, hay gây gổ. Có xu hướng bi quan, tiêu cực. Dễ bị căng thẳng, stress.
    Kiểu tương tác của Họa Hại:
      --- Sống khép kín, ít giao tiếp
      --- Dễ gây gổ, mâu thuẫn với người khác
      --- Thường đóng vai trò người gây rối, phá hoại
      --- Quá nhiều Họa Hại sẽ dễ bị cô lập, xa lánh`,
  },
  "Tuyệt mệnh": {
    description: `Tính cách: Cô độc, ít nói, khó gần. Có xu hướng bi quan, tiêu cực. Dễ bị căng thẳng, stress.
    Tài vận: Có tài lộc kém, dễ bị mất mát tiền bạc. Có nhiều khoản chi tiêu không cần thiết. Dễ bị lừa gạt, mất tiền oan.
    Sự nghiệp: Có sự nghiệp không ổn định, dễ gặp khó khăn, trắc trở. Dễ bị đồng nghiệp, cấp trên ghét bỏ.
    Tình cảm: Có tình cảm không ổn định, dễ xảy ra mâu thuẫn, cãi vã. Dễ bị phản bội, lừa dối.
    Hôn nhân: Có cuộc sống gia đình không hạnh phúc, dễ xảy ra ly hôn. Có con cái không ngoan ngoãn, hiếu thảo.
    Mối quan hệ: Có ít bạn bè, dễ bị cô lập. Dễ gây gổ, mâu thuẫn với người khác.
    Sức khỏe: Có sức khỏe kém, dễ mắc bệnh hiểm nghèo. Có tinh thần bi quan, dễ tuyệt vọng.
    Học tập: Có khả năng học tập kém, khó đạt kết quả cao. Dễ bị xao nhãng, mất tập trung.
    Ưu điểm: Có khả năng chịu đựng cao, không dễ bỏ cuộc. Có ý chí mạnh mẽ, không dễ bị khuất phục.
    Nhược điểm: Cô độc, ít nói, khó gần. Có xu hướng bi quan, tiêu cực. Dễ bị căng thẳng, stress.
    Kiểu tương tác của Tuyệt Mệnh:
      --- Sống khép kín, ít giao tiếp
      --- Dễ gây gổ, mâu thuẫn với người khác
      --- Thường đóng vai trò người gây rối, phá hoại
      --- Quá nhiều Tuyệt Mệnh sẽ dễ bị cô lập, xa lánh`,
  },
  "Ngũ quỷ": {
    description: `Tính cách: Nóng nảy, dễ cáu gắt, hay gây gổ. Có xu hướng bi quan, tiêu cực. Dễ bị căng thẳng, stress.
    Tài vận: Có tài lộc kém, dễ bị mất mát tiền bạc. Có nhiều khoản chi tiêu không cần thiết. Dễ bị lừa gạt, mất tiền oan.
    Sự nghiệp: Có sự nghiệp không ổn định, dễ gặp khó khăn, trắc trở. Dễ bị đồng nghiệp, cấp trên ghét bỏ.
    Tình cảm: Có tình cảm không ổn định, dễ xảy ra mâu thuẫn, cãi vã. Dễ bị phản bội, lừa dối.
    Hôn nhân: Có cuộc sống gia đình không hạnh phúc, dễ xảy ra ly hôn. Có con cái không ngoan ngoãn, hiếu thảo.
    Mối quan hệ: Có ít bạn bè, dễ bị cô lập. Dễ gây gổ, mâu thuẫn với người khác.
    Sức khỏe: Có sức khỏe kém, dễ mắc bệnh tật. Có tinh thần bất an, dễ lo lắng.
    Học tập: Có khả năng học tập kém, khó đạt kết quả cao. Dễ bị xao nhãng, mất tập trung.
    Ưu điểm: Có khả năng phản biện tốt, không dễ bị lừa gạt. Có ý chí mạnh mẽ, không dễ bỏ cuộc.
    Nhược điểm: Nóng nảy, dễ cáu gắt, hay gây gổ. Có xu hướng bi quan, tiêu cực. Dễ bị căng thẳng, stress.
    Kiểu tương tác của Ngũ Quỷ:
      --- Sống khép kín, ít giao tiếp
      --- Dễ gây gổ, mâu thuẫn với người khác
      --- Thường đóng vai trò người gây rối, phá hoại
      --- Quá nhiều Ngũ Quỷ sẽ dễ bị cô lập, xa lánh`,
  },
  "Lục sát": {
    description: `Tính cách: Dễ bị cảm xúc chi phối, hay thay đổi. Có xu hướng bi quan, tiêu cực. Dễ bị căng thẳng, stress.
    Tài vận: Có tài lộc kém, dễ bị mất mát tiền bạc. Có nhiều khoản chi tiêu không cần thiết. Dễ bị lừa gạt, mất tiền oan.
    Sự nghiệp: Có sự nghiệp không ổn định, dễ gặp khó khăn, trắc trở. Dễ bị đồng nghiệp, cấp trên ghét bỏ.
    Tình cảm: Có tình cảm không ổn định, dễ xảy ra mâu thuẫn, cãi vã. Dễ bị phản bội, lừa dối.
    Hôn nhân: Có cuộc sống gia đình không hạnh phúc, dễ xảy ra ly hôn. Có con cái không ngoan ngoãn, hiếu thảo.
    Mối quan hệ: Có ít bạn bè, dễ bị cô lập. Dễ gây gổ, mâu thuẫn với người khác.
    Sức khỏe: Có sức khỏe kém, dễ mắc bệnh tật. Có tinh thần bi quan, dễ nản chí.
    Học tập: Có khả năng học tập kém, khó đạt kết quả cao. Dễ bị xao nhãng, mất tập trung.
    Ưu điểm: Có khả năng sáng tạo, đổi mới. Có ý chí mạnh mẽ, không dễ bỏ cuộc.
    Nhược điểm: Dễ bị cảm xúc chi phối, hay thay đổi. Có xu hướng bi quan, tiêu cực. Dễ bị căng thẳng, stress.
    Kiểu tương tác của Lục Sát:
      --- Sống khép kín, ít giao tiếp
      --- Dễ gây gổ, mâu thuẫn với người khác
      --- Thường đóng vai trò người gây rối, phá hoại
      --- Quá nhiều Lục Sát sẽ dễ bị cô lập, xa lánh`,
  },
};
export default dominantEnergyMeanings;
